import React from 'react'
import SelectBox from '../../../components/SelectBox'
import { HiOutlineRefresh } from 'react-icons/hi'

const TransactionFilters = ({
  filterOptions,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchTermChange,
  stats,
  isMobile,
  onRefresh,
  refreshing,
}) => {
  return (
    <div className={`flex flex-col rounded-md bg-customLightMilkWhite/80 ${isMobile ? 'p-2 gap-2' : 'p-4 gap-4'} shadow-custom dark:bg-customSurface dark:shadow-none border dark:border-custom_dark_secondary/40`}>
      <div className={`flex flex-col ${isMobile ? 'gap-1' : 'gap-3'} md:flex-row md:items-center md:justify-between`}>
        <div className="text-lg font-semibold text-customPrimaryText dark:text-customHeading">
          Pending Balance Transfers
        </div>
        <div className="text-xs font-medium uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
          Monitor and act on incoming requests before they expire.
        </div>
      </div>
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
        <div className="w-full lg:w-56 flex flex-col gap-2">
          <button
            type="button"
            onClick={() => onRefresh?.()}
            disabled={refreshing || !onRefresh}
            className="flex items-center justify-center gap-2 rounded-lg border bg-customAccentBlue text-white px-3 py-2 text-sm font-semibold transition hover:bg-customAccentBlue/80 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-customSurface dark:text-customAccent"
          >
            <HiOutlineRefresh className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
            <span>Refresh</span>
          </button>
          <SelectBox
            selected={selectedFilter}
            setSelected={onFilterChange}
            options={filterOptions}
            isMobile={isMobile}
          />
        </div>
        <div className="relative w-full lg:max-w-xs">
          <input
            type="text"
            value={searchTerm}
            onChange={(event) => onSearchTermChange(event.target.value)}
            className="w-full rounded-lg border border-customBorder/40 bg-white/80 py-2 pl-10 pr-4 text-sm text-customPrimaryText outline-none transition focus:border-customAccent focus:ring-2 focus:ring-customAccent/30 dark:border-white/10 dark:bg-custom_dark_primary dark:text-customLightMilkWhite"
            placeholder="Search by username, remark, or transaction no."
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-customSecondaryText dark:text-customMuted"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 105.25 5.25a7.5 7.5 0 0011.4 11.4z"
            />
          </svg>
        </div>
        <div className="flex flex-1 flex-col gap-2 rounded-xl border border-dashed border-customAccent/30 bg-customPredawn/5 p-3 text-sm text-customPrimaryText dark:border-customAccent/40 dark:bg-customSurfaceMuted/60 dark:text-customHeading">
          <div className="flex items-center justify-between">
            <span className="font-medium">Total pending</span>
            <span className="text-base font-semibold text-customAccent dark:text-customAccentBlue">
              {stats.total}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
              Deposit
            </span>
            <span className="font-semibold text-customFontGreen">
              {stats.deposit}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-xs uppercase tracking-wide text-customSecondaryText dark:text-customMuted">
              Withdrawal
            </span>
            <span className="font-semibold text-customFontRed">
              {stats.withdraw}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TransactionFilters
